import axios from "axios";
import { IP } from "../index.js";

// 查询页面配置
export async function selectConfig() {
  var resp = await axios.post(`${IP}/admin/vipConfig/selectAll`, {});
  return resp.data;
}
// 修改页面配置
export async function updateConfig(data) {
  var resp = await axios.post(`${IP}/admin/vipConfig/update`, {
    ...data,
  });
  return resp.data;
}
